/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomToolTip.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Tooltip, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

function CustomToolTip({
  children,
  length,
  style,
  type = "string",
  title = null,
  props = {},
}) {
  const getTitle = () => {
    if (title) return title;
    return typeof children === "string" && children.length > length
      ? children
      : "";
  };

  return (
    <Tooltip
      arrow
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "#000", // pure black tooltip
            color: "#fff",
            borderRadius: 0,
            boxShadow: 3,
            p: 1,
            "& .MuiTooltip-arrow": {
              color: "#000",
            },
          },
        },
      }}
      {...props}
      title={getTitle()}
    >
      {type === "string" && (
        <Typography sx={{ ...style }}>
          {typeof children === "string" && children.length > length
            ? `${children.slice(0, length)}...`
            : children}
        </Typography>
      )}
      {type === "component" && children}
    </Tooltip>
  );
}

CustomToolTip.propTypes = {
  children: PropTypes.node,
  length: PropTypes.number,
  style: PropTypes.object,
  type: PropTypes.string,
  title: PropTypes.node,
  props: PropTypes.object,
};

export default CustomToolTip;
